// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_l4-0";
export var discountCodeInput = "_l4-1";